import { create } from "zustand";
import type { Plant } from "../types";

interface PlantsState {
	modalOpen: boolean;
	editingItem: Plant | null;
	defaultOrganizationId: string | null;
}

interface PlantsActions {
	openCreateModal: (organizationId?: string) => void;
	openEditModal: (item: Plant) => void;
	closeModal: () => void;
}

type PlantsStore = PlantsState & PlantsActions;

export const usePlantsStore = create<PlantsStore>((set) => ({
	modalOpen: false,
	editingItem: null,
	defaultOrganizationId: null,

	openCreateModal: (organizationId) => {
		set({ modalOpen: true, editingItem: null, defaultOrganizationId: organizationId ?? null });
	},

	openEditModal: (item) => {
		set({ modalOpen: true, editingItem: item });
	},

	closeModal: () => {
		set({ modalOpen: false, editingItem: null, defaultOrganizationId: null });
	},
}));
